import { AwEventStore } from "@/models/AwEventStore"
import { AwEventType } from "@/models/AwEventType"
import { AnalyticsClient } from "@/services/AnalyticsService"
import { container } from "tsyringe"

export function setupSocialShare() {
  let analytics = container.resolve(AnalyticsClient)
  function registerSocialShare(momentId: number) {
    var event: AwEventStore = {
      eventType: AwEventType.MomentShared,
      momentId: momentId
    }
    analytics.register(event)
  }
  return { registerSocialShare }
}
